/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_GuideInputs */

const en_cad_download_guide = /** @type {(inputs: Cad_Download_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the step-by-step download & install guide`)
};

/**
* | output |
* | --- |
* | "Read the step-by-step download & install guide" |
*
* @param {Cad_Download_GuideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_guide = /** @type {((inputs?: Cad_Download_GuideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_GuideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_guide(inputs)
});
export { cad_download_guide as "cad.download.guide" }